//List of different language we gonna use (key:ENGLISH ; value "en" )

export const LOCALES = {
  ENGLISH: "en",
  FRENCH: "fr",
};
